export default __webpack_public_path__ + "static/media/alarm.2f087394.svg";